import axios from "axios";

const instance = axios.create({
    baseURL: "/backend/",
    headers: {
        Authorization: "",
    },
});

export default instance;